module.exports = __webpack_public_path__ + "static/hero-image-1x-16b4da21188dbfdcd042df2f8b6fae26.png";